/**
 * Theme: Shape
 * - This theme is the default theme for the Floating Awesome Button.
 * - You can define the theme in the backend: Setting > Design > Template > Name.
 */
export class Shape_Theme {
  /**
   * Get styles object
   * @param {Object} styles
   * @returns {Object}
   */
  static get_styles_object(styles) {
    styles.button.shape = item.template.shape != 'none' ? item.template.shape : fab_design.template.shape;
    styles.button.shape = `fab-template-shape-${styles.button.shape}`;

    return styles;
  }
}
